"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleCase = titleCase;
/**
 * Convert a string to title case
 * @param str
 * @returns
 */
function titleCase(str) {
    if (str === str.toUpperCase()) {
        return str;
    }
    return str
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
//# sourceMappingURL=stringHelper.js.map